import React, { ReactElement } from 'react';
import { KatIcon } from '@amzn/katal-react';
import { User } from '../../types/Search';

type MentionsButtonProps = {
  user: User,
  mentionId: number,
  options?: {
    isSelected?: boolean,
    isGreyedOut?: boolean,
    showBlockIcon?: boolean
  },
  onMouseEnter: CallableFunction,
  onClick: CallableFunction
};

const MentionsButton = (
  {
    user, mentionId, options, onMouseEnter, onClick,
  }: MentionsButtonProps,
): ReactElement => {
  const bgColorClass = options?.isSelected ? 'bg-kat-jungle-mist' : 'bg-transparent';
  const textColorClass = options?.isGreyedOut ? 'text-kat-submarine' : 'text-kat-eastern';
  return (
    <button
      role="option"
      aria-selected={!!options?.isSelected}
      id={`mention-option-${mentionId}`}
      data-testid={`mention-option-${mentionId}`}
      type="button"
      onMouseEnter={() => {
        onMouseEnter(mentionId);
      }}
      onClick={() => {
        onClick({ username: user.username, userId: user.userId });
      }}
      className={`flex w-full cursor-pointer items-center justify-items-center border-0 p-2 ${bgColorClass} ${textColorClass}`}
    >
      <div className="mr-2 inline-block h-6 w-6 flex-none overflow-hidden rounded-full">
        <img className="mx-auto block max-w-full" src={user.avatarSrc} alt="User Avatar" />
      </div>
      <div className="flex w-full break-all text-left line-clamp-1">
        {`${user.username}`}
      </div>
      {!!options?.showBlockIcon
        && (
          <div className="flex-none items-center">
            <KatIcon name="block" size="small" className="ltr:ml-1 rtl:mr-1" />
          </div>
        )}
    </button>
  );
};

MentionsButton.defaultProps = {
  options: {
    isSelected: false,
    isDisabled: false,
    showBlockIcon: false,
  },
};

export default MentionsButton;
